export function ImageCarrouselElementButtonViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: true,
    isElementDeletable : false,
    editElementModalController: 'editImageCarrouselElementButtonController',
    editElementModalTemplate: require('./editImageCarrouselElementButton.modal.html'),
    angularTemplate: require('./ImageCarrouselElementButtonView.html'),

    afterEditElement: function(oldElementData, newElementData) {
      this.updatePortAndLink();
    },

    updateBox: function() {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
      this.updatePortAndLink();
    },

    /**
     * As postback button can have outgoing links,
     * but web URL buttons cannot,
     * we need to update the port accordingly after editing the button,
     * possibly removing an existing outgoing link  
     */
    updatePortAndLink: function() {
      if (this.model.hasPort('out') && !this.currentTypeHasOutPort()) {
        this.model.removeOutPort('out');
      } else if (!this.model.hasPort('out') && this.currentTypeHasOutPort()) {
        this.model.addOutPort('out');
      }
    },

    /**
     * Tells whether this button should have an outPort
     * and hence can be connected to other boxes of the graph,
     * depending on its selected type.
     */
    currentTypeHasOutPort() {
      return this.angularScope.elementData.type !== 'url';
    },

    getViewLabel: function () {
      const parentView = this.getParentView();
      if (parentView) {
        const button_header_label = services.$translate.instant('parameters/quick_replies/details/graph/line_image_carrousel/button_header');
        const indexOnLabel = parentView.getElementIndexAndTotalElementsAsText(this.angularScope.elementData.Index);
        return `${button_header_label} ${indexOnLabel}`;
      }
      return '';
    },

});
}
